import React from "react";
import { MapPin, Phone, Clock, Star } from "lucide-react";
import { BUSINESS, OFFER, LEGAL_NAME } from "../mock";
import { CtaButton, StarRating } from "./common";

export const FinalCTA = () => (
  <section className="relative overflow-hidden bg-brand-sage py-20">
    <div className="mx-auto max-w-3xl px-5 text-center md:px-8">
      <p className="font-sans text-sm font-semibold uppercase tracking-[0.2em] text-brand-gold">Intro Special</p>
      <h2 className="mt-4 font-serif text-3xl text-brand-ivory md:text-5xl">
        Still on the fence? Lock your ${OFFER.price} spot before they fill up.
      </h2>
      <div className="mt-6 flex items-end justify-center gap-3">
        <span className="font-serif text-2xl text-brand-ivory/60 line-through">${OFFER.regPrice}</span>
        <span className="font-serif text-5xl font-semibold text-brand-ivory">${OFFER.price}</span>
      </div>
      <div className="mt-8">
        <CtaButton toForm className="bg-brand-gold text-brand-ink shadow-[0_10px_30px_-8px_rgba(190,160,91,0.7)] hover:bg-brand-golddark hover:text-white">
          Claim My Spot
        </CtaButton>
      </div>
    </div>
  </section>
);

export const Footer = () => {
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, "").split("/")[0];
  return (
  <footer className="bg-brand-ink py-14 text-brand-ivory">
    <div className="mx-auto max-w-6xl px-5 md:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-full border border-brand-gold">
              <span className="font-serif text-lg font-semibold text-brand-gold">{BUSINESS.monogram}</span>
            </div>
            <span className="font-serif text-lg">{BUSINESS.name}</span>
          </div>
          <p className="mt-4 max-w-xs font-sans text-sm leading-relaxed text-brand-ivory/70">
            A patient-focused, results-driven medical spa serving {BUSINESS.city} and {BUSINESS.region}.
          </p>
          <div className="mt-4 flex items-center gap-2">
            <StarRating size={14} />
            <span className="font-sans text-sm text-brand-ivory/80">{BUSINESS.rating} · {BUSINESS.reviewCount} Google reviews</span>
          </div>
        </div>
        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-brand-gold">Visit Us</h4>
          <ul className="mt-4 space-y-3 font-sans text-sm text-brand-ivory/80">
            <li className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 flex-shrink-0 text-brand-gold" /> {BUSINESS.address}</li>
            <li className="flex items-center gap-2.5"><Phone size={16} className="flex-shrink-0 text-brand-gold" /> {BUSINESS.phone}</li>
            <li className="flex items-center gap-2.5"><Clock size={16} className="flex-shrink-0 text-brand-gold" /> {BUSINESS.hours}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-brand-gold">Ready to glow?</h4>
          <p className="mt-4 font-sans text-sm text-brand-ivory/70">
            Reserve your {OFFER.name} for just ${OFFER.price}.
          </p>
          <CtaButton toForm className="mt-5 bg-brand-gold text-brand-ink hover:bg-brand-golddark hover:text-white" size="md">
            Claim My Spot
          </CtaButton>
        </div>
      </div>
      <div className="mt-12 border-t border-white/10 pt-6 text-center font-sans text-xs text-brand-ivory/50">
        <div className="mb-3 flex items-center justify-center gap-4">
          <a href={`/privacy?slug=${slug}`} data-testid="footer-privacy-link" className="transition hover:text-brand-ivory/90">Privacy Policy</a>
          <span className="text-brand-ivory/30">·</span>
          <a href={`/terms?slug=${slug}`} data-testid="footer-terms-link" className="transition hover:text-brand-ivory/90">Terms &amp; SMS</a>
        </div>
        © {new Date().getFullYear()} {LEGAL_NAME}. All rights reserved. · Individual results may vary.
      </div>
    </div>
  </footer>
  );
};
